/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/usersFilter.scss';

import {ChangeKeyFunction, CloseButton, WithBackground} from '@dvrd/dvr-controls';
import React, {KeyboardEventHandler, MouseEventHandler} from 'react';
import {NullString, UserFilter} from "../../../../util/interfaces";
import {BolmateButton, BolmateInput} from "../../../controls";

interface Props {
    onChangeFilter: ChangeKeyFunction<string>;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onClose: MouseEventHandler;
    filter: UserFilter;
    active: boolean;
}

export default function UsersFilter(props: Props) {
    const {filter, onChangeFilter, onClose, onSubmit, active} = props;

    function renderBody() {
        return (
            <div className='body-container'>
                {renderText('User ID', filter.user_id, 'user_id')}
                {renderText('Account ID', filter.account_id, 'account_id')}
                {renderText('Customer ID', filter.customer_id, 'customer_id')}
                {renderText('Voornaam', filter.firstname, 'firstname', true)}
                {renderText('Achternaam', filter.lastname, 'lastname')}
                {renderText('Bedrijfsnaam', filter.company_name, 'company_name')}
                {renderText('E-mailadres', filter.email, 'email')}
            </div>
        )
    }

    function renderText(label: string, value: NullString, key: keyof UserFilter, autoFocus: boolean = false) {
        return (
            <BolmateInput onChange={onChangeFilter(key)} value={value ?? ''} label={label} onEnter={onSubmit}
                          autoFocus={autoFocus}/>
        )
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='users-filter default-popup'>
                <div className='header-container'>
                    <label className='header-title'>Filter klanten</label>
                    <CloseButton onClick={onClose}/>
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BolmateButton onClick={onClose} label='Annuleren' secondary/>
                    <BolmateButton onClick={onSubmit} label='Toepassen'/>
                </div>
            </div>
        </WithBackground>
    )
}